import { EndpointModulesWebComponent } from './component/EndpointModulesWebComponent';
import { WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS } from '../webcomponents.constants';

export { EndpointModulesWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS, EndpointModulesWebComponent);
